import type { Feature } from 'geojson'
import { ToGeoJSON } from '../../../types/apiModels'
import { escapeHtml } from '../../../utils/escapeHtml'
import { popupRow } from '../../../utils/popupContent'
import { formattedHectaresArea } from '../utils'

const TYPE_LABELS: Record<string, string> = {
  strata: 'Estrato',
  exclusion_area: 'Área de exclusión',
  other_polygon: 'Otro polígono',
  other_site: 'Otro sitio',
}

export const buildStratumPopupContent = (
  feature: Feature,
  quNameById: Record<string, string | null | undefined>,
): string => {
  const props = feature?.properties ?? {}
  const rows: string[] = []

  if (props.id) rows.push(popupRow('ID', escapeHtml(props.id)))
  if (props.name) rows.push(popupRow('Nombre', escapeHtml(props.name)))

  const quName = props.quantificationUnitId ? quNameById[props.quantificationUnitId] : undefined
  if (quName) rows.push(popupRow('QU', escapeHtml(quName)))

  rows.push(popupRow('Área', escapeHtml(formattedHectaresArea(feature as Partial<ToGeoJSON>))))

  const typeLabel = props.type ? (TYPE_LABELS[props.type] ?? props.type) : undefined
  if (typeLabel) rows.push(popupRow('Tipo', escapeHtml(typeLabel)))

  return rows.join('')
}
